<template>
  <div class="pageWrapper_home">
    <div class="fan_massage">
      <div class="top_header">
        <!-- <div class="back-icon">
          <i class="material-icons">arrow_back</i>
        </div>-->
        <div class="back-icon" @click="goBack()">
          <i class="material-icons">arrow_back</i>
        </div>
        <div class="container">
          <Header update_profile_txt=" Update Your Profile" icon_txt="arrow_forward" />
          <div class="title_acceptedMessage">
            <h1>{{$t('fanHistory')}}({{videosLength}})</h1>
            <!-- <h1>{{$t('fanHistory')}}({{this.listOfVideos && this.listOfVideos.filter(c=>c.status!="rejected").length}})</h1> -->
          </div>
        </div>
      </div>
      <div class="container">
        <div class="middlePannel_acceptedMessage middlePannel_history">
          <div class="history">
            <!-- <span
              v-if="listOfVideos && !listOfVideos.length"
              class="no_data"
            >{{$t('noHistoryAvailable')}}!</span> -->
            <ul >
              <li v-for="videosList in listOfVideos" :key="videosList.media_id">
                <div class="list_item">
                  <div class="update-txt">{{videosList.time}}</div>
                  <div
                    class="fanvideo-play-img"
                    @click="playVideo(videosList.media_id, videosList)"
                  >
                    <img :src="videosList.thumbnail" v-if="videosList.thumbnail" />
                    <img src="../assets/images/video_overlay.png" v-else />
                  </div>
                  
                  <ul>
                    <!-- <div class="fanHistory"> -->
                    <li class="user_action_detail">
                      <!-- <div class="user_action_detail"> -->
                      <span class="users-profile users-profile-history">
                        <img :src="videosList.user_profile_pic" v-if="videosList.user_profile_pic" />
                        <img src="../assets/images/user_images.png" v-else />
                      </span>
                      <div class="details_profile">
                        <span class="users-video">
                          {{$t('createdVideofor')}}
                          <b>{{videosList.video_for}}</b>
                        </span>

                        <div class="likes-cmt">
                          <i class="material-icons">thumb_up</i>
                          {{videosList && videosList.likes && videosList.likes.length}} {{$t('likes')}}
                          <i
                            class="material-icons"
                          >comment</i>
                          {{videosList && videosList.comments && videosList.comments.length }} {{$t('Comments')}}
                        </div>
                      </div>
                      <!-- </div> -->
                    </li>
                  </ul>
                  <!-- </div> -->
                </div>
              </li>
               <infinite-loading @infinite="infiniteHandler">
              <template slot="no-more">{{ $t("NoRecordsavailable") }}</template>
            </infinite-loading>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Header from "../components/Header";
import Btn from "../components/Btn";
import Footer from "../components/Footer";
import { toaster } from "../utils/helper";
import ApiCaller from "../utils/apicaller";
import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";
Vue.use(InfiniteLoading);
export default {
  name: "FanHistory",
  components: {
    Footer,
    Btn,
    Header,
    InfiniteLoading
  },
  data() {
    return {
      listOfallvideo: [],
      listOfVideos: [],
      request_id: "",
      loading: false,
      comments: [],
      likes: [],
      limit: 0,
      videosLength: 0
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    infiniteHandler($state) {
        ApiCaller(`/celebrity/responded_requests/${this.limit}/10`, "get").then(
          data => {
            if (data.data.length) {
              this.limit += 10;
              const testlistOfVideos = data.data.filter(c => c.status != "rejected");
              this.listOfVideos = this.listOfVideos.concat(testlistOfVideos)
              
              $state && $state.loaded();
            } else {
              $state && $state.complete();
            }
          }
        );
      
    },
    // fanVideosList() {
    //   this.loading = true;
    //   this.$store
    //     .dispatch({ type: "respondedRequest" })
    //     .then(data => {
    //       this.listOfVideos = data.data.filter(c => c.status != "rejected");
    //       this.loading = false;
    //     })
    //     .catch(err => {
    //       toaster(
    //         this,
    //         this.$t("somethingWentwrong"),
    //         "top-center",
    //         2000
    //       );
    //     });
    // },
    playVideo(id, vdlist) {
      sessionStorage.setItem("fan_detail", JSON.stringify(vdlist));
      this.$router.push({
        path: `/fan-historydetails/${id}`
        // query: { vdlist: vdlist }
      });
    }
  },
  mounted() {
    this.$store
      .dispatch({ type: "totalUploadedVideos" })
      .then(data => {
        this.videosLength = data.data.total_videos;
      })
      .catch(err => {
        this.loading = !this.loading;
      });
  }
};
</script>

